import { render, staticRenderFns } from "./historical_no_code.vue?vue&type=template&id=7e05d7ce&scoped=true"
import script from "./historical_no_code.vue?vue&type=script&lang=js"
export * from "./historical_no_code.vue?vue&type=script&lang=js"
import style0 from "./historical_no_code.vue?vue&type=style&index=0&id=7e05d7ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e05d7ce",
  null
  
)

export default component.exports